





















































import Vue from 'vue';
import { propOfType } from '@/services/utils';

export default Vue.extend({
  name: 'OcupationRate',
  props: {
    // Datos de entrada
    occupiedSeats: propOfType<number>(0),
    totalSeats: propOfType<number>(0),
    availableSeats: propOfType<number>(0),
    // Apariencia
    size: { type: Number, default: 42 },
    strokeWidth: { type: Number, default: 5 },
    trackColor: { type: String, default: '#E5E7EB' }, // gray-200
    trackOpacity: { type: Number, default: 1 },
    showLabel: { type: Boolean, default: true },
    labelColor: { type: String, default: '#F70E48' },
    progressColor: { type: String, default: '#F70E48' },
    labelType: { type: String, default: 'percent' }, // 'percent' | 'fraction'

    // Animación
    animate: { type: Boolean, default: true },
    animationMs: { type: Number, default: 700 },
  },
  computed: {
    tooltipText(): string {
      const vm: any = this;
      return `Tasa de ocupación: ${vm.displayLabel} | ${vm.occupiedSeats} pax${vm.occupiedSeats > 1 ? 's' : ''} / ${vm.safeSeats} asientos`;
    },
    safeSeats(): number {
      const vm: any = this;
      const s = Number(vm.totalSeats) || 0;
      return s > 0 ? s : 0;
    },
    percentage(): number {
      const vm: any = this;
      if (vm.safeSeats === 0) return 0;
      const p = Math.round((Number(vm.occupiedSeats) / vm.safeSeats) * 100);
      return Math.max(0, Math.min(100, p));
    },
    sizePx(): string {
      const vm: any = this;
      return `${vm.size}px`;
    },
    center(): number {
      const vm: any = this;
      return vm.size / 2;
    },
    radius(): number {
      const vm: any = this;
      return (vm.size - vm.strokeWidth) / 2;
    },
    circumference(): number {
      const vm: any = this;
      return 2 * Math.PI * vm.radius;
    },
    dashOffset(): number {
      // Calcula el offset a partir del porcentaje (0% => lleno, 100% => vacío)
      const vm: any = this;
      return vm.circumference * (1 - vm.percentage / 100);
    },
    progressStyle(): Record<string, string> {
      const vm: any = this;
      return vm.animate
        ? { transition: `stroke-dashoffset ${vm.animationMs}ms ease, stroke 200ms ease` }
        : {};
    },
    displayLabel(): string {
      const vm: any = this;
      return vm.labelType === 'fraction'
        ? `${vm.passengers}/${vm.safeSeats}`
        : `${vm.percentage}%`;
    },
    availableLabel(): string {
      const vm: any = this;
      return `${vm.availableSeats} disponible${vm.availableSeats !== 1 ? 's' : ''}`;
    },
    labelFontSize(): number {
      // proporcional al tamaño del círculo
      const vm: any = this;
      return Math.round(vm.size * 0.28);
    },
    textDy(): string {
      // ajuste fino vertical para centrar el texto
      const vm: any = this;
      return `${Math.round(vm.size * 0.09)}`;
    },
  },
});
